import React, { useCallback, useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { Formik } from 'formik';
import { FiSend } from 'react-icons/fi';
import { useHistory } from 'react-router-dom';

import api from '../../../../services/api';
import { useToast } from '../../../../hooks/useToast';
import {
  FieldBlock,
  FooterButton,
  Label,
  ModalSubtitle,
  Section,
  SectionHead,
  Select,
} from '../EditWorkerModal/styles';

interface IWorker {
  id: string;
}

interface ISyndicate {
  id: string;
  nome_fantasia: string;
}

interface IProps {
  show: boolean;
  handleShow: (value: boolean) => void;
  worker: IWorker;
}

const ForwardWorkerModal: React.FC<IProps> = ({ show, handleShow, worker }) => {
  const { addToast } = useToast();
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [unions, setUnions] = useState<ISyndicate[]>([]);

  const handleClose = useCallback(() => {
    handleShow(false);
  }, [handleShow]);

  const handleForwardWorker = useCallback(
    async values => {
      try {
        await api.post('/workers/forward', values);
        addToast({
          title: 'Sucesso',
          body: 'Trabalhador redirecionado com sucesso.',
        });
      } catch (error) {
        addToast({
          title: 'Erro',
          body: 'Ocorreu algum erro ao tentar redirecionar o trabalhador.',
        });
      } finally {
        history.replace('/workers');
      }
    },
    [addToast, history],
  );

  useEffect(() => {
    const loadData = async () => {
      const loadedUnions = await api.get('/unions');
      setUnions(loadedUnions.data);
      setLoading(false);
    };

    if (loading) {
      loadData();
    }
  }, [loading]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Formik
        initialValues={{
          workerId: worker.id,
          syndicateId: '',
        }}
        onSubmit={handleForwardWorker}
      >
        {({ values, handleSubmit, handleChange }) => (
          <form onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <div>
                <Modal.Title style={{ fontSize: 18, fontWeight: 700 }}>
                  Encaminhar Trabalhador
                </Modal.Title>
                <ModalSubtitle>
                  Selecione o sindicato de destino para este trabalhador
                </ModalSubtitle>
              </div>
            </Modal.Header>

            <Modal.Body style={{ background: '#fafbfc', padding: 20 }}>
              <Section>
                <SectionHead>
                  <span className="badge">
                    <FiSend size={16} />
                  </span>
                  <div>
                    <h4>Sindicato destino</h4>
                    <span className="subtitle">
                      Escolha o sindicato para encaminhar
                    </span>
                  </div>
                </SectionHead>

                <FieldBlock>
                  <Label>Sindicato</Label>
                  <Select
                    value={values.syndicateId}
                    onChange={handleChange('syndicateId')}
                  >
                    <option value="">Selecione o sindicato</option>
                    {unions.map(union => (
                      <option key={union.id} value={union.id}>
                        {union.nome_fantasia}
                      </option>
                    ))}
                  </Select>
                </FieldBlock>
              </Section>
            </Modal.Body>

            <Modal.Footer>
              <FooterButton
                type="button"
                $variant="secondary"
                onClick={handleClose}
              >
                Cancelar
              </FooterButton>
              <FooterButton type="submit">Encaminhar</FooterButton>
            </Modal.Footer>
          </form>
        )}
      </Formik>
    </Modal>
  );
};

export default ForwardWorkerModal;
